export type LeaveType = "cuti" | "izin" | "sakit" | "lainnya";

export type LeaveStatus = "pending" | "approved" | "rejected" | "none";

export const LEAVE_TYPE_LABEL: Record<LeaveType, string> = {
  cuti: "Cuti",
  izin: "Izin",
  sakit: "Sakit",
  lainnya: "Lainnya",
};

export const LEAVE_STATUS_META: Record<
  LeaveStatus,
  { label: string; className: string }
> = {
  pending: { label: "MENUNGGU", className: "bg-slate-100 text-slate-500" },
  approved: { label: "DITERIMA", className: "bg-emerald-100 text-emerald-700" },
  rejected: { label: "DITOLAK", className: "bg-rose-100 text-rose-700" },
  none: { label: "-", className: "bg-slate-100 text-slate-500" },
};

/** Satu pengajuan berhalangan hadir (cuti/izin/sakit/lainnya). */
export interface LeaveRequest {
  id: number;
  idKaryawan: number;
  type: LeaveType;
  startDate: string; // "YYYY-MM-DD"
  endDate: string; // "YYYY-MM-DD"
  keterangan: string;
  attachmentName: string | null;
  status: LeaveStatus;
  submittedAt: string; // ISO 8601
}

/** Payload yang dikirim dari form pengajuan. */
export interface LeaveRequestPayload {
  idKaryawan: number;
  type: LeaveType;
  startDate: string;
  endDate: string;
  keterangan: string;
  attachment: File | null;
}